import { simplePath } from "../utils.js";
const GET_TEAM_MEMBERS_PATH = 'v2/team/:teamId/members';
function get_team_member_list_path(params) {
    return simplePath(GET_TEAM_MEMBERS_PATH, params);
}
export { GET_TEAM_MEMBERS_PATH, get_team_member_list_path };
